/**
 * Error thrown when Analytix initialization fails
 */
export class AnalytixInitializeError extends Error {
  constructor(message: unknown) {
    const msg =
      typeof message === 'string'
        ? message
        : message instanceof Error
          ? message.message
          : String(message)
    super(`Failed to initialize Analytix: ${msg}`)
  }
}

/**
 * Error thrown when Analytix instance is enabled, but not initialized
 */
export class AnalytixNotInitializedError extends Error {
  constructor() {
    super('Analytix instance is not initialized')
  }
}

/**
 * Error thrown when sending an Analytix event fails
 */
export class AnalytixSendEventError extends Error {
  constructor(eventName: string, error: unknown) {
    const msg =
      typeof error === 'string'
        ? error
        : error instanceof Error
          ? error.message
          : String(error)
    super(`Analytix event ${eventName} failed to send: ${msg}`)
  }
}
